import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { Reveal, Eyebrow } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function Services() {
  useTitle("Professional Financial Services");
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="services-page">
      <section className="bg-[#0A192F] relative overflow-hidden py-16 lg:py-24">
        <div className="absolute inset-0 hero-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Eyebrow light>Professional Financial Services</Eyebrow>
          <h1 className="font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl leading-[1.1]">
            Accounting, taxation & advisory for businesses.
          </h1>
          <p className="mt-5 text-slate-300 text-base max-w-xl leading-relaxed">
            The professional wing of SterlingNest — the same rigour we teach, applied to your books.
          </p>
        </div>
      </section>
      <section className="py-16 lg:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-card-${s.slug}`}
                className="group block h-full bg-white rounded-2xl border border-slate-200 p-7 hover:border-[#0F5132]/50 hover:shadow-[0_16px_40px_rgba(10,25,47,0.1)] hover:-translate-y-1 transition-all duration-300"
              >
                <span className="font-mono-sn text-xs font-bold text-[#C59B27] tracking-widest">0{i + 1}</span>
                <h2 className="font-display font-bold text-lg text-[#0A192F] mt-3">{s.name}</h2>
                <p className="text-sm text-[#486581] leading-relaxed mt-2">{s.short_desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#0F5132] group-hover:gap-3 transition-all">
                  Learn more <ArrowRight size={15} />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12">
          <p className="text-xs text-[#627D98] leading-relaxed max-w-3xl" data-testid="services-disclaimer">
            Mutual fund and insurance services are provided subject to applicable regulations. We do not guarantee
            investment returns or loan approvals; all approvals remain subject to the respective institution's policies.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
